import React, { Component } from 'react';
import NavMenu from '../../components/navMenu/navMenu.jsx';
import HeaderMenu from '../../components/headerMenu/headerMenu.jsx';
import { getToken, loadZhuKeToken, getLoginShopInfo, messageShow, millisecondToDate, isNotNull, formatDuration } from '../../utils/http.js';
import { Select, Button, Progress, Pagination } from 'element-react';
import MyLoading from '../../components/showLoading/showLoading.jsx';
import NewUserGuide from '../../components/newUserGuide/index.jsx';
import TableNavChange from '../../components/tableNavChange/tableNavChange';
import PlatformName from '../../components/platformName/index.jsx';
import NoImagesCard from '../../components/noImagesCard/index.jsx';
import { getAfterSalePageData, SyncAfterSaleOrder, getLastSyncTime, getAfterSaleSyncStatus, getAfterSaleNumber } from '../../utils/api';
import '../../assets/css/common.less';
import './index.less';

class officialWarehouseAfterSalesOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            setGuide: false,
            setGuideV2: false,
            selectShopId: "",//当前登录的店铺id，非阿里的
            selectShopName: "",
            selectPlatformType: "",
            orderStatusList: [
                { id: 0, value: "AfterSaleing", title: "售后中", active: true, num: 0 },
                { id: 1, value: "AfterSaleSuccess", title: "售后完成", active: false, num: 0 },
                { id: 2, value: "AllAfterSale", title: "全部", active: false, num: 0 }
            ],
            syncOrderStatusTaskProgress: 100,//同步进度
            lastSyncTimeByShop: '',//最后同步时间，店铺的维度
            afterSaleOrderList: [],
            totals: 0,
            loadingTitle: '加载订单信息...',
            selectProductType: 'ProductID',
            searchParams: {
                PageIndex: 1, // 分页index
                PageSize: 10, // 页码大小
                OrderType: 0, // 0 平台订单号，1，采购单订单号
                PlatformOrderId: '', // 平台订单id
                Days: 30, // 查询最近天数
                OrderBy: 'asc', // 订单排序，asc,最新订单在后，desc 最新订单在前
                SupplierWangWang: '', // 供应商旺旺
                ProductID: '', // 商品id搜索
                ProductSubject: '', // 商品标题搜索
                AfterSaleStatus: 0, // 0 售后中 1 售后完成 2 全部
                IsWareHouseAfterSaleOrder: true
            },
        };
    }

    componentDidMount() {
        var zhukeToken = getToken();
        var that = this;
        if (zhukeToken != "")
            that.loadData();
        else {
            setTimeout(() => {
                var zhukeTokenTwo = getToken();
                if (zhukeTokenTwo == "") {
                    var hasZhukeLoginShopTokens = localStorage.getItem("hasZhukeLoginShopTokens") || null;
                    if (hasZhukeLoginShopTokens != null && hasZhukeLoginShopTokens != "" && hasZhukeLoginShopTokens != undefined) {
                        loadZhuKeToken(hasZhukeLoginShopTokens);
                        setTimeout(() => {
                            var zhukeTokenThree = getToken();
                            if (zhukeTokenThree != "")
                                that.loadData();
                            else
                                that.setState({ isShowWarn: true });
                        }, 500);
                    } else
                        that.setState({ isShowWarn: true });
                } else
                    that.loadData();
            }, 500);
        }
    }

    changeLeftNav = (name) => {
        this.props.history.replace(name)
    }

    loadData = () => {
        var shopInfo = getLoginShopInfo();
        const setGuide = localStorage.getItem("SetOfficialWarehouseAfterSalesOrderGuide-" + shopInfo.loginShopId);
        const setGuideV2 = localStorage.getItem("setOfficialWarehouseAfterSalesOrderGuideV2-" + shopInfo.loginShopId);
        var that = this;
        this.setState({
            selectShopId: shopInfo.loginShopId,
            selectShopName: shopInfo.loginShopName,
            selectPlatformType: shopInfo.loginShopPlatformType,
            setGuide: setGuide ? true : false,
            setGuideV2: setGuideV2 ? true : false,
        }, () => {
            that.syncOrderByStatus();
            that.initPageData();
            that.getAfterSalePageNumber();
        })
    }

    // 售后数量统计
    async getAfterSalePageNumber() {
        let { searchParams, selectPlatformType, selectShopId, orderStatusList } = this.state;
        const obj = { ...searchParams, PlatformType: selectPlatformType, ShopId: selectShopId, PageIndex: undefined, PageSize: undefined  };
        await getAfterSaleNumber(obj).then((response) => {
            if (response.Success) {
                const data = response.Data;
                orderStatusList.forEach(item => {
                    item.num = data[item.value];
                });
                this.setState({ orderStatusList: orderStatusList });
            }
        });
    }

    // 初始化列表数据
    async initPageData() {
        this.setState({ isLoading: true });
        let { searchParams, selectPlatformType, selectShopId } = this.state;
        const obj = { ...searchParams, PlatformType: selectPlatformType, ShopId: selectShopId };
        await getAfterSalePageData(obj).then((response) => {
            if (response.Success) {
                let afterSaleOrderList = response.Data.Orders;
                let totals = response.Data.TotalCount;


                afterSaleOrderList.forEach(function (item) {
                    if (isNotNull(item.OverdueTime)) {
                        var nowTime = new Date().getTime();
                        var LastTime = new Date(item.OverdueTime).getTime();
                        var LastShipTime = LastTime - nowTime;

                        if (LastShipTime > 0) {
                            item.LastShipTimeValue = formatDuration(LastShipTime);
                        } else {
                            item.LastShipTimeValue = "已超时 " + millisecondToDate(-LastShipTime);
                        }
                    } else {
                        item.LastShipTimeValue = '-';
                    }
                })

                this.setState({
                    afterSaleOrderList,
                    totals,
                    isLoading: false,
                });
            } else {
                this.setState({ isLoading: false });
            }
        });
    }

    // 售后订单同步状态
    async syncOrderByStatus() {
        const { selectShopId, selectPlatformType } = this.state;
        const list = [];
        list.push({
            Key: selectShopId,
            Value: selectPlatformType
        });
        const res = await getAfterSaleSyncStatus({ Sid_PlatformType: list });
        if (res.RequestError == true) {
            this.setState({ isLoading: false, syncOrderStatusTaskProgress: 100 });
            return;
        }
        if (res.Success) {
            if (res.Data == 100) {
                this.setState({ syncOrderStatusTaskProgress: res.Data });
                this.shopLastSyncTime(selectShopId, selectPlatformType);
            } else {
                this.setState({ syncOrderStatusTaskProgress: res.Data });
                setTimeout(() => {
                    this.syncOrderByStatus();
                }, 10000);
            }
        } else {
            this.setState({ syncOrderStatusTaskProgress: 100 });
        }
    }

    // 售后订单同步最后时间
    async shopLastSyncTime(shopId, platformType) {
        const obj = {
            ShopIds: [shopId],
            SyncType: 1,
            PlatformType: platformType
        }
        const res = await getLastSyncTime(obj);
        if (res.RequestError == true) {
            return;
        }
        if (res.Success) {
            const lastSyncTime = res.Data;
            this.setState({ lastSyncTimeByShop: lastSyncTime });
        } else {
            messageShow("获取最后同步时间，错误信息" + res.Message, 'error');
        }
    }

    gotoHistory = (pathname) => {
        this.props.history.push({ pathname: pathname });
    }

    sellerOrderRender(item) {
        return (
            <tr>
                <td colspan="2" className="orderTables-headerTd">
                    <div className="orderTables-header" style={{ backgroundColor: "#fff9f0" }}>
                        <div className="orderTables-header-left" style={{ marginLeft: '8px' }}>
                            <div className="orderTables-header-left-item">
                                <span style={{ flex: 1, whiteSpace: 'nowrap' }}>
                                    订单编号：
                                    <a style={{ color: '#169bd5' }} target="_blank" href='https://fxg.jinritemai.com/ffa/morder/order/list?btm_ppre=a2427.b76571.c902327.d871297&btm_pre=a2427.b76571.c902327.d871297&btm_show_id=d1b0b262-50a6-4114-ad89-2b58f15fa7b7'>{item.PlatformOrderId}</a>
                                </span>
                                <span style={{ flex: 1 }}>
                                    付款时间：<i className="mainColor">{item.OrderPayTime || '-'}</i>
                                </span>
                            </div>
                            <div className="orderTables-header-left-item" style={{ marginTop: '10px' }}>
                                <span style={{ flex: 1, whiteSpace: 'nowrap' }}>
                                    售后编号：
                                    <a style={{ color: '#169bd5' }} target="_blank" href='https://fxg.jinritemai.com/ffa/maftersale/aftersale/list?btm_ppre=a0.b0.c0.d0&btm_pre=a2427.b76571.c902327.d871297&btm_show_id=79df3ee2-971e-4ea5-bad3-4206cd5a24ec'>{item.AfterSaleId}</a>
                                </span>
                                <span style={{ flex: 1 }}>
                                    申请时间：<i className="mainColor">{item.ApplyTime}</i>
                                </span>
                            </div>
                        </div>
                        <div className='orderTables-header-right' style={{ justifyContent: "flex-end", flexDirection: 'column', alignItems: 'end', marginRight: '8px', padding: '6px 0' }}>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <PlatformName platformType={item.PlatformType} isHidePatformName={true} />
                                <span class="mainColor" style={{ marginLeft: "3px" }}>{this.state.selectShopName}</span>
                            </div>
                            <div style={{ display: 'flex', marginTop: '6px' }}>
                                {
                                    item.IsWareHouseAddressNoSame ? <span className='popoverCommon' style={{ marginRight: '10px', backgroundColor: '#ffb9b9', padding: '4px', color: '#ff2000', borderRadius: '4px' }}>
                                        <span>退货地址异常</span>
                                        <div className='popoverCommon-warn' style={{ bottom: '29px', color: '#000', left: '0px', fontSize: '12px' }}>
                                            买家退货地址与官方仓地址不一致，请重新同步官方仓地址至店铺，再让买家重新申请售后
                                        </div>
                                    </span> : null
                                }
                                <span style={{ backgroundColor: '#63badf', padding: '4px', color: '#fff', borderRadius: '4px' }}>官方仓退货</span>
                            </div>
                        </div>
                    </div>
                </td>
            </tr>
        )
    }

    //售后订单商品列表页面
    sellerOrderItemRender = (item, itemProduct, itemProductIndex, itemProductLength) => {
        return (
            <tr style={{ padding: "1px 5px" }} key={itemProductIndex} className={itemProductIndex > 1 ? "hideTr tr" + itemProductIndex : "tr" + itemProductIndex}>
                <td style={{ width: "380px" }}>
                    <div class="productShow" style={{ alignItems: 'center' }}>
                        <div class="productShow-imgWrap">
                            {
                                itemProduct.ProductImgUrl ? <img src={itemProduct.ProductImgUrl} alt="产品图片" /> :
                                    <NoImagesCard />
                            }
                        </div>
                        <ul style={{ paddingRight: '44px', color: '#333' }}>
                            <li title="商品标题">{itemProduct.ProductSubject}</li>
                            <li style={{ marginTop: '6px' }}>
                                <span>规格：</span>
                                <span>{itemProduct.Color}{itemProduct.Size}</span>
                            </li>
                            <li style={{ marginTop: '6px' }}>
                                <span>商品ID：</span>
                                <span>{itemProduct.ProductID}</span>
                            </li>
                        </ul>
                        <div class="productNum mainColor">
                            <span>￥{itemProduct.Price}</span>
                            <span style={{ marginTop: '6px' }}>x{itemProduct.AfterSaleCount}</span>
                        </div>
                    </div>
                </td>
                {
                    itemProductIndex === 0 ?
                        <td rowspan={itemProductLength > 1 ? 2 : itemProductLength} className="hebin" style={{ width: '200px' }}>
                            <div style={{ marginLeft: '12px' }}>
                                <span>订单金额: ￥{item.TotalAmount} （含运费: ￥{item.Freight}）</span>
                            </div>
                            <div style={{ marginTop: "8px", marginBottom: "8px", color: 'red', marginLeft: '12px' }}>
                                <span>实退金额: ￥{item.RefundAmount}</span>
                            </div>
                            {
                                item.AfterSaleStatus == 0 && item.PurchaseOrder && item.PurchaseOrder.AfterInfo && item.PurchaseOrder.AfterInfo.AfterSaleStatus == 3 ?
                                    <a target="_blank" style={{ marginLeft: '76px', color: '#169bd5' }} href='https://fxg.jinritemai.com/ffa/maftersale/aftersale/list?btm_ppre=a0.b0.c0.d0&btm_pre=a2427.b76571.c902327.d871297&btm_show_id=bb4905ce-cd6f-41ed-bac4-144da06101ed'>售后详情</a>
                                    : null
                            }
                        </td> : null
                }
            </tr>
        )
    }

    // 采购订单信息页面
    renderBuyerOrderTr = (item) => {
        return (
            <React.Fragment>
                <tr style={{ padding: "1px 5px" }}>
                    <td style={{ width: "380px", padding: 0 }}>
                        {item.PurchaseOrderItems.map((pItem, pIndex) => {
                            return <div class="productShow" key={pItem.PurchaseOrderItemCode} style={{ borderBottom: pIndex == item.PurchaseOrderItems.length - 1 ? "unset" : '1px solid #e2e2e2', padding: '12px', alignItems: 'center' }}>
                                <div class="productShow-imgWrap">
                                    <img src={pItem.ProductImageUrl} alt="" />
                                </div>
                                <ul style={{ color: '#333', height: '52px' }}>
                                    <li title="商品标题" data-logger-action-type="dgj_action_order_item">{pItem.ProductName}</li>
                                    <li>
                                        <span>规格：{pItem.SkuName}</span>
                                    </li>
                                </ul>
                                <div class="productNum mainColor">
                                    <span>￥{pItem.SkuPrice}</span>
                                    <span style={{ marginTop: '6px' }}>x{pItem.SkuCount}</span>
                                </div>
                            </div>
                        })}
                    </td>
                    <td className="hebin" style={{ width: '200px' }}>
                        <div style={{ marginLeft: '20px' }}>
                            <span>订单金额: ￥{item.TotalAmount} （含运费: ￥{item.Freight}）</span>
                        </div>
                        <div style={{ marginTop: "8px", marginBottom: "8px", color: 'red', marginLeft: '20px' }}>
                            <span>实退金额: ￥{item.AfterInfo ? item.AfterInfo.RefundAmount : '-'}</span>
                        </div>
                        <div style={{ marginTop: "8px", marginBottom: "8px", color: 'red', marginLeft: '20px' }}>
                            <span>实退运费: ￥{item.AfterInfo ? item.AfterInfo.RefundFreight : '-'}</span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" style={{ backgroundColor: '#f0f0f0', padding: '14px' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', fontSize: '12px', color: '#000' }}>
                            <div style={{ width: '180px' }}><span>售后状态：</span><span className="mainColor">{item.AfterInfo ? item.AfterInfo.AfterSaleStatusDesc : '-'}</span></div>
                            <div style={{ display: 'flex', marginTop: '12px' }}>
                                <div style={{ flex: 1 }}>
                                    <span>官方仓订单：</span>
                                    {
                                        item.AfterInfo && item.AfterInfo.WareHouseAfterSaleItems && item.AfterInfo.WareHouseAfterSaleItems.length ?
                                            <a style={{ color: '#169bd5' }} target="_blank" href='https://air.1688.com/app/channel-fe/distribution-work/sales_return_warehouse.html#/order/return-requested'>
                                                {item.AfterInfo.WareHouseAfterSaleItems[0].AfterSaleId}
                                            </a> : '-'
                                    }
                                </div>
                                <div style={{ flex: 1 }}>
                                    <span>官方仓订单状态：</span>
                                    <span className="mainColor">
                                        {item.AfterInfo && item.AfterInfo.WareHouseAfterSaleItems && item.AfterInfo.WareHouseAfterSaleItems.length ? item.AfterInfo.WareHouseAfterSaleItems[0].AfterSaleStatusDesc : '-'}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </td>
                </tr>
            </React.Fragment>
        )
    }

    // 指引-不再提示
    onCloseGuide() {
        localStorage.setItem("SetOfficialWarehouseAfterSalesOrderGuide-" + this.state.selectShopId, 1);
        this.setState({
            setGuide: true
        });
    }

    onCloseGuideV2() {
        localStorage.setItem("setOfficialWarehouseAfterSalesOrderGuideV2-" + this.state.selectShopId, 1);
        this.setState({
            setGuideV2: true
        });
    }

    handleChangeDays = (value) => {
        const { searchParams } = this.state;
        this.setState({
            searchParams: {
                ...searchParams,
                Days: value
            }
        });
    }

    handleChangeOrderBy = (value) => {
        const { searchParams } = this.state;
        this.setState({
            searchParams: {
                ...searchParams,
                OrderBy: value
            }
        });
    }

    handleChangeOrderType = (value) => {
        const { searchParams } = this.state;
        this.setState({
            searchParams: {
                ...searchParams,
                OrderType: value
            }
        });
    }

    handleChangePlatformOrderId = (event) => {
        const { searchParams } = this.state;
        const value = event.target.value.trim();
        this.setState({
            searchParams: { ...searchParams, PlatformOrderId: value }
        });
    }

    handleChangeSupplierWangWang = (event) => {
        const { searchParams } = this.state;
        const value = event.target.value;
        this.setState({
            searchParams: { ...searchParams, SupplierWangWang: value }
        });
    }

    handleChangeProductType = (value) => {
        const { searchParams } = this.state;
        this.setState({
            searchParams: {
                ...searchParams,
                ProductID: value == "ProductID" ? searchParams.ProductSubject : "",
                ProductSubject: value == "ProductSubject" ? searchParams.ProductID : "",
            },
            selectProductType: value
        });
    }

    handleChangeProductContent = (event) => {
        const { selectProductType, searchParams } = this.state;
        const value = event.target.value;
        if (selectProductType === 'ProductID') {
            this.setState({
                searchParams: { ...searchParams, ProductID: value, ProductSubject: '' }
            });
        } else {
            this.setState({
                searchParams: { ...searchParams, ProductID: '', ProductSubject: value }
            });
        }
    }

    // 点击查询按钮
    searchData() {
        const { searchParams } = this.state;
        this.setState({
            searchParams: {
                ...searchParams,
                PageIndex: 1
            }
        }, () => {
            this.initPageData();
            this.getAfterSalePageNumber();
        });
    }

    //切换tab
    changeTabs(item) {
        const { searchParams } = this.state;
        this.setState({
            searchParams: {
                ...searchParams,
                PageIndex: 1,
                AfterSaleStatus: item.id
            },
        }, () => {
            this.initPageData();
            this.getAfterSalePageNumber();
        });
    }

    // 同步订单
    async handleSyncAfterSaleOrder() {
        let shopByLists = [];
        shopByLists.push(this.state.selectShopId);
        const data = {
            SyncSids: shopByLists
        }
        this.setState({ syncOrderStatusTaskProgress: 0 });
        const res = await SyncAfterSaleOrder(data);
        if (res.RequestError == true) {
            this.setState({ isLoading: false, syncOrderStatusTaskProgress: 0 });
            return;
        }
        if (res.Success) {
            this.syncOrderByStatus();
            this.initPageData();
            this.getAfterSalePageNumber();
        } else {
            messageShow("同步错误：" + res.Message, 'error');
            this.setState({ isLoading: false, syncOrderStatusTaskProgress: 0 });
        }
    }

    changeCurrent = (current) => {
        const { searchParams } = this.state;
        this.setState({
            searchParams: {
                ...searchParams,
                PageIndex: current
            }
        }, () => {
            this.initPageData();
        })
    }

    changePageSize = (size) => {
        const { searchParams } = this.state;
        this.setState({
            searchParams: {
                ...searchParams,
                PageIndex: 1,
                PageSize: size
            },
        }, () => {
            this.initPageData();
        });
    }

    render() {

        const { setGuide, setGuideV2, selectShopId, searchParams, totals, isLoading, loadingTitle, selectProductType, afterSaleOrderList,
            orderStatusList, syncOrderStatusTaskProgress } = this.state;

        return (
            <div className='wrap'>
                <HeaderMenu />
                <main>
                    <div className='wrap-left scroll-x' >
                        <NavMenu changeNav={this.changeLeftNav} defaultActive={"/autoAfterSaleSet"} />
                    </div>
                    <div className="wrap-right">
                        <div className='official_warehouse_afterSalesOrder-wrap'>
                            {
                                setGuide == false && selectShopId ? <div className='ora_guide'>
                                    <div className='ora_guide-box'>
                                        <div className='ora_guide-item'>
                                            <div className='ora_guide-title'>1.开通1688官方仓退货服务</div>
                                            <div style={{ padding: '14px 0px 6px 24px' }}>开通1688官方仓退货服务</div>
                                            <a style={{ marginLeft: '24px' }} href="https://air.1688.com/app/channel-fe/distribution-work/sales_return_warehouse.html#/home" target="_blank">{'立即前往>'}</a>
                                        </div>
                                        <div className='ora_guide_arrow'>
                                            <span className='ora_guide_arrow-line'></span>
                                            <span className='ora_guide_arrow-triangle'></span>
                                        </div>
                                        <div className='ora_guide-item'>
                                            <div className='ora_guide-title'>2.开启官方仓自动售后</div>
                                            <div style={{ padding: '8px 12px 6px 10px' }}>自动售后设置中开启官方仓自动售后</div>
                                            <span onClick={() => this.gotoHistory("/autoAfterSaleSet")}>{'立即前往>'}</span>
                                        </div>
                                        <div className='ora_guide_arrow'>
                                            <span className='ora_guide_arrow-line'></span>
                                            <span className='ora_guide_arrow-triangle'></span>
                                        </div>
                                        <div className='ora_guide-item'>
                                            <div className='ora_guide-title'>3.同步官方仓</div>
                                            <div style={{ padding: '8px 12px 6px 10px' }}>同步官方仓，获取1688官方仓地址</div>
                                            <span onClick={() => this.gotoHistory("/officialReturnWarehouse")}>{'立即前往>'}</span>
                                        </div>
                                        <div className='ora_guide_arrow'>
                                            <span className='ora_guide_arrow-line'></span>
                                            <span className='ora_guide_arrow-triangle'></span>
                                        </div>
                                        <div className='ora_guide-item'>
                                            <div className='ora_guide-title'>4.关联供应商</div>
                                            <div style={{ padding: '8px 12px 6px 10px' }}>地址库中关联供应商，自动向供应商发起售后申请</div>
                                            <span onClick={() => this.gotoHistory("/officialReturnWarehouse")}>{'立即前往>'}</span>
                                        </div>
                                        <div className='ora_guide_arrow'>
                                            <span className='ora_guide_arrow-line'></span>
                                            <span className='ora_guide_arrow-triangle'></span>
                                        </div>
                                        <div className='ora_guide-item'>
                                            <div className='ora_guide-title'>5.同步至店铺</div>
                                            <div style={{ padding: '8px 12px 6px 10px' }}>地址库中同步官方仓至店铺，买家按照该地址退回</div>
                                            <span onClick={() => this.gotoHistory("/officialReturnWarehouse")}>{'立即前往>'}</span>
                                        </div>
                                        <div className='ora_guide_arrow'>
                                            <span className='ora_guide_arrow-line'></span>
                                            <span className='ora_guide_arrow-triangle'></span>
                                        </div>
                                        <div className='ora_guide-item'>
                                            <div className='ora_guide-title'>6.店铺后台同意售后</div>
                                            <div style={{ padding: '8px 12px 6px 10px' }}>手工在店铺后台同意退货退款</div>
                                            <a href="https://fxg.jinritemai.com/ffa/maftersale/aftersale/list?btm_ppre=a0.b0.c0.d0&btm_pre=a2427.b76571.c902327.d871297&btm_show_id=bb4905ce-cd6f-41ed-bac4-144da06101ed" target="_blank">{'立即前往>'}</a>
                                        </div>
                                        <div className='ora_guide_arrow'>
                                            <span className='ora_guide_arrow-line'></span>
                                            <span className='ora_guide_arrow-triangle'></span>
                                        </div>
                                        <div className='ora_guide-item'>
                                            <div className='ora_guide-title'>7.自动创建官方仓售后单</div>
                                            <div style={{ padding: '8px 12px 6px 10px' }}>官方仓退货的售后单，系统会自动创建对应的官方仓售后单</div>
                                            <a href="https://air.1688.com/app/channel-fe/distribution-work/sales_return_warehouse.html#/order/return-requested" target="_blank">{'前往查看>'}</a>
                                        </div>
                                    </div>
                                    <div className='no_tip-btn' onClick={() => this.onCloseGuide()}>
                                        不再提示
                                    </div>
                                </div> : null
                            }
                            <div className='searchWrap mywrap' style={{ marginTop: '12px', display: 'flex', alignItems: 'center' }}>
                                <Select value={searchParams.Days} onChange={this.handleChangeDays} style={{ marginRight: '6px', width: '100px' }}>
                                    <Select.Option value={7} label="7天" />
                                    <Select.Option value={15} label="15天" />
                                    <Select.Option value={30} label="30天" />
                                    <Select.Option value={60} label="60天" />
                                    <Select.Option value={90} label="90天" />
                                </Select>
                                <Select value={searchParams.OrderBy} onChange={this.handleChangeOrderBy} style={{ width: "150px", marginRight: "6px" }}>
                                    <Select.Option label="最新订单在后" value="asc" />
                                    <Select.Option label="最新订单在前" value="desc" />
                                </Select>
                                <Select value={searchParams.OrderType} onChange={this.handleChangeOrderType} style={{ width: "150px", marginRight: "6px" }}>
                                    <Select.Option label="平台订单编号" value={0} />
                                    <Select.Option label="平台售后编号" value={2} />
                                    <Select.Option label="采购订单" value={1} />
                                    <Select.Option label="采购售后订单" value={3} />
                                    {/* <Select.Option label="官方仓订单" value={4} /> */}
                                </Select>
                                <input style={{ width: "192px", marginRight: "6px" }} type="text" onChange={this.handleChangePlatformOrderId} placeholder="多个平台订单编号(,)分隔" />
                                <input style={{ width: "192px", marginRight: "6px" }} type="text" placeholder="供应商旺旺" onChange={this.handleChangeSupplierWangWang} />
                                <Select value={selectProductType} onChange={this.handleChangeProductType} style={{ width: "120px", marginRight: "6px" }}>
                                    <Select.Option value="ProductID" label="商品ID" />
                                    <Select.Option value="ProductSubject" label="商品标题" />
                                </Select>
                                <input style={{ width: "192px", marginRight: "6px" }} type="text" onChange={this.handleChangeProductContent} placeholder='输入值' />
                                <Button type="primary" style={{ marginRight: "4px" }} onClick={() => { this.searchData() }}>查询</Button>
                            </div>
                            <div className='mywrap orderListWarp'>
                                {
                                    setGuideV2 == false && selectShopId ? <div className='ora_tip'>
                                        <span>目前仅支持开通了1688官方仓退货服务的抖音店铺进行官方仓退货</span>
                                        <span style={{ cursor: 'pointer', color: '#169bd5' }} onClick={() => this.onCloseGuideV2()}>不再提示</span>
                                    </div> : null
                                }
                                <div className="zk-maiwrap" style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", marginTop: 0 }}>
                                    <div className="NavChangeAndSyncOrderBtn">
                                        <TableNavChange distributionStatus={orderStatusList} changeNav={(item) => { this.changeTabs(item) }} allShow={true} />
                                        <div className="progress-wrap">
                                            <Progress
                                                percentage={syncOrderStatusTaskProgress}
                                                type="circle"
                                                width="40"
                                                strokeWidth="3"
                                                style={{ marginRight: "15px" }}
                                            />
                                            {
                                                syncOrderStatusTaskProgress == 100 || syncOrderStatusTaskProgress == "100" ?
                                                    <span className="syncOrderBtn-span" onClick={() => this.handleSyncAfterSaleOrder()}>同步售后单</span>
                                                    : <span style={{ color: "#999" }}>正在同步中...</span>
                                            }
                                            <span className="warnColor" style={{ marginLeft: "10px" }}>上次同步时间:{this.state.lastSyncTimeByShop}</span>
                                        </div>
                                    </div>
                                    <table class="table-style01 orderList" id="orderList_table">
                                        <thead>
                                            <tr style={{ backgroundColor: "#f5f5f5" }}>
                                                <th colspan="20" style={{ padding: "8px 0" }}>
                                                    <div className='tableWrap-header'>
                                                        <div className='tableWrap-header-right'>
                                                            <div className='tableWrap-header-right-title' style={{ width: '50%', textAlign: 'center' }}>平台售后单信息</div>
                                                            <div className='tableWrap-header-right-title' style={{ width: '50%', textAlign: 'center' }}>采购售后单信息</div>
                                                        </div>
                                                    </div>
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                afterSaleOrderList.length === 0 ?
                                                    <tr>
                                                        <td className="noneData" colSpan="20">
                                                            <div className="noneData-wrap">
                                                                <i className="iconfont icon-wushuju"></i>
                                                                <span className="noneData-title">暂无数据</span>
                                                            </div>
                                                        </td>
                                                    </tr> : null
                                            }

                                            {
                                                afterSaleOrderList.length > 0 && afterSaleOrderList.map((item, index) => {
                                                    return <tr key={index}>
                                                        <td valign="top" style={{ padding: '20px 20px 0 0', borderBottom: 'unset' }}>
                                                            <table className="orderTables table-style02">
                                                                {this.sellerOrderRender(item)}
                                                                {
                                                                    item.AfterSaleOrderItems.map((itemProduct, itemProductIndex) =>
                                                                        this.sellerOrderItemRender(item, itemProduct, itemProductIndex, item.AfterSaleOrderItems.length)
                                                                    )
                                                                }
                                                                <tr>
                                                                    <td colspan="2" style={{ backgroundColor: '#f0f0f0', padding: '14px', color: '#333' }}>
                                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                                                                <div style={{ marginBottom: '8px' }}>售后状态：<span>{item.AfterSaleStatusDesc}</span></div>
                                                                                <div style={{ marginBottom: '8px' }}>快递单号：{item.ReturnTrackingNo || '-'}</div>
                                                                                <div>售后地址：{item.ReturnAddress || '-'}</div>
                                                                            </div>
                                                                            <div style={{ backgroundColor: '#f9d8d8', padding: '8px 12px', borderRadius: '4px' }}>剩余时间：{item.LastShipTimeValue}</div>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </table>
                                                        </td>
                                                        <td valign="top" style={{ padding: '20px 0 0 0', borderBottom: 'unset' }}>
                                                            <table class="orderTables table-style02">
                                                                <tr>
                                                                    <td colspan="2" class="orderTables-headerTd" style={{ backgroundColor: "#ebf9ff" }}>
                                                                        <div class="orderTables-header" style={{ padding: '11px 16px', alignItems: 'center' }}>
                                                                            <div class="orderTables-header-left">
                                                                                <div className="orderTables-header-left-item">
                                                                                    <span style={{ flex: 1, whiteSpace: 'nowrap' }}>
                                                                                        采购订单：{item.PurchaseOrder ? <a style={{ color: '#169bd5' }} target="_blank" href='https://work.1688.com/?spm=a262jm.22620049.quickentry.dbuylist.4c334aadw07h9U&_path_=buyer2017Base/2017buyerbase_trade/buyList'>{item.PurchaseOrder.PurchaseOrderId}</a> : '-'}
                                                                                    </span>
                                                                                    <span style={{ flex: 1 }}>创建时间：{item.PurchaseOrder ? item.PurchaseOrder.CreateTime : '-'}</span>
                                                                                </div>
                                                                                <div className="orderTables-header-left-item" style={{ marginTop: '10px' }}>
                                                                                    <span style={{ flex: 1, whiteSpace: 'nowrap' }}>
                                                                                        售后订单：{item.PurchaseOrder && item.PurchaseOrder.AfterInfo ? 
                                                                                        <a style={{ color: '#169bd5' }} target="_blank" href='https://work.1688.com/?spm=a360q.8274423.workmenu.dbuyerref.356f4c9arFFbdh&_path_=buyer2017Base/2017buyerbase_trade/buyerRefundList'>{item.PurchaseOrder.AfterInfo.AfterSaleId}</a> : '-'}
                                                                                    </span>
                                                                                    <span style={{ flex: 1 }}>创建时间：{item.PurchaseOrder && item.PurchaseOrder.AfterInfo ? item.PurchaseOrder.AfterInfo.ApplyTime : '-'}</span>
                                                                                </div>
                                                                            </div>
                                                                            {
                                                                                item.PurchaseOrder ? <div>
                                                                                    <span style={{ marginRight: '6px' }}>{item.PurchaseOrder.SupplierLoginId}</span>
                                                                                    <a className="iconfont icon-wangwang" onClick={() => { window.open("https://amos.alicdn.com/getcid.aw?charset=utf-8&uid=" + item.PurchaseOrder.SupplierLoginId + "&site=cnalichn") }}></a>
                                                                                </div> : null
                                                                            }
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                {/* 采购订单信息 */}
                                                                {item.PurchaseOrder ? this.renderBuyerOrderTr(item.PurchaseOrder) : null}
                                                            </table>
                                                        </td>
                                                    </tr>
                                                })
                                            }
                                        </tbody>
                                    </table>
                                    <div className="agination-wrap">
                                        <Pagination
                                            onCurrentChange={this.changeCurrent.bind(this)}
                                            onSizeChange={this.changePageSize.bind(this)}
                                            layout="total,sizes,prev, pager, next"
                                            total={totals}
                                            pageSize={searchParams.PageSize}
                                            currentPage={searchParams.PageIndex}
                                            pageSizes={[10, 30, 50]} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </main>
                <MyLoading isLoading={isLoading} isStopOperate={true} fullCenter={true} title={loadingTitle} />
                <NewUserGuide></NewUserGuide>
            </div>
        )
    }
}

export default officialWarehouseAfterSalesOrder;


// WEBPACK FOOTER //
// ./src/pages/officialWarehouseAfterSalesOrder/index.jsx